import { ProcessedAssignedCoupons } from '@app/data/clients/monolithClients/assigned-coupons/types';
import { useRef, useState } from 'react';
import { CartCheckoutClient } from '../../cartCheckoutClient';
import { DispatchActionsType, StateDispatch } from '../types';
import {
  AsyncHookState,
  AsyncRequestResult,
  StateCode,
} from './AsyncHookState';

type HookState = AsyncHookState<never> & {
  data?: ProcessedAssignedCoupons;
};
type AsyncResult = AsyncRequestResult<never> & {
  data?: ProcessedAssignedCoupons;
};

export const useGetAssignedCoupons = ({
  client,
  dispatch,
}: {
  client: CartCheckoutClient;
  dispatch: StateDispatch;
}) => {
  const abortController = useRef<AbortController>();
  const [result, setResult] = useState<HookState>({});

  const handler = async (): Promise<AsyncResult> => {
    if (abortController.current) {
      abortController.current.abort();
    }

    const newAbortController = new AbortController();
    abortController.current = newAbortController;

    setResult((prev) => ({ ...prev, state: StateCode.LOADING }));

    return client
      .fetchAssignedCoupons(newAbortController.signal)
      .then((res) => {
        if (res.coupon_applied) {
          dispatch({ type: DispatchActionsType.SET_CART, payload: res.cart });
        }

        return {
          state: StateCode.SUCCESS,
          data: res,
        };
      })
      .catch(() => {
        return {
          state: StateCode.FAILED,
        };
      })
      .then((res) => {
        setResult(res);
        return res;
      });
  };

  return {
    ...result,
    handler,
  };
};
